export enum STATUS {
    Overview = 'OVERVIEW',
    Solved = 'SOLVED',
    Diagnosis = 'DIAGNOSIS',
    Resolution = 'RESOLUTION',
}